import { UseLogOptions, LogbookEntry } from "@hakit/core";

export function DummyComponentLogOptions(props: Partial<UseLogOptions>) {
  return props;
}

export function DummyComponentLogEntry(props: Partial<LogbookEntry>) {
  return props;
}
